import { gql } from "apollo-boost";

export const LOGIN = gql`
  mutation loginUsingEid($phonenumber: String) {
    loginUsingEid(phonenumber: $phonenumber) {
      claim
    }
  }
`;
